import { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";

import ModalForm, { Field, FieldType } from "../../../../components/ModalForm";
import { updateTag } from "../../../../services/api/admin/tags";
import { Tag } from "../../../../types/api/admin/tag";
import {
    FieldErrors,
    REQUIRED_FIELD,
    clearFieldError,
    notifyFieldErrors,
} from "../../../../utils/errors";

type Props = {
    isOpen: boolean;
    tag: Partial<Tag>;
    onSubmit?: () => void;
    onClose: () => void;
};

const EditTagModal: FC<Props> = ({ isOpen, tag, onSubmit, onClose }) => {
    const [name, setName] = useState<string>(tag.name || "");
    const [fieldErrors, setFieldErrors] = useState<FieldErrors>({});

    const fields: Field<FieldType>[] = [
        {
            id: "name",
            label: "Nouveau nom du tag",
            type: "text",
            value: name,
            onChange: (value) => {
                setName(value);
                setFieldErrors((prev) => clearFieldError(prev, "name"));
            },
            error: fieldErrors.name,
        },
    ];

    useEffect(() => {
        if (tag) {
            setName(tag.name || "");
            setFieldErrors({});
        }
    }, [tag]);

    const handleOnSubmit = async () => {
        try {
            if (!tag.id) {
                throw new Error("Tag ID is missing");
            }

            if (name.trim() === "") {
                const nameErrors = { name: REQUIRED_FIELD };
                setFieldErrors(nameErrors);
                notifyFieldErrors(nameErrors, {
                    message: "Le nom du tag ne peut pas être vide.",
                    type: "warning",
                });
                return;
            }

            await updateTag(tag.id || "", { name });
            toast.success("Tag modifié avec succès");
            setName("");
            setFieldErrors({});
            onSubmit?.();
        } catch (error) {
            console.error("Error editing tag:", error);
            toast.error("Erreur lors de l'édition du tag");
        }
    };

    return (
        <ModalForm
            open={isOpen}
            title="Editer un tag"
            fields={fields}
            onSubmit={handleOnSubmit}
            handleClose={onClose}
            size="small"
            submitLabel="Modifier"
        />
    );
};

export default EditTagModal;
